import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productSetting: [],
  loading: false,
  error: null,
};

const productSettingSlice = createSlice({
  name: "productSetting",
  initialState,
  reducers: {
    setProductSetting: (state, action) => {
      console.log("Setting product settings in Redux:", action.payload);
      state.productSetting = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setProductSetting, setLoading, setError } =
  productSettingSlice.actions;
export default productSettingSlice.reducer;
